import { Duration } from 'luxon';
import { useEffect, useState } from 'react';
import { Input } from '@core/ui';
import { useTranslation } from 'react-i18next';

export const TimestampInput = ({ timestamp, onChange }: { timestamp: Duration; onChange: (timestamp: Duration) => void }) => {
    const { t } = useTranslation();
    const [hours, setHours] = useState<number>(timestamp.hours);
    const [minutes, setMinutes] = useState<number>(timestamp.minutes);
    const [seconds, setSeconds] = useState<number>(timestamp.seconds);

    useEffect(() => {
        const scaled = timestamp.rescale();
        setHours(scaled.hours);
        setMinutes(scaled.minutes);
        setSeconds(scaled.seconds);
    }, [timestamp]);

    useEffect(() => {
        let asSeconds = seconds;
        asSeconds += minutes * 60;
        asSeconds += hours * 60 * 60;
        if (asSeconds < 0) {
            asSeconds = 0;
        }

        onChange(Duration.fromMillis(asSeconds * 1000));
    }, [hours, minutes, seconds]);

    return (
        <fieldset className="flex justify-center mx-auto">
            <legend className="text-center text-base">{t('Editor.Timestamp.Legend')}</legend>
            <Input type="number" label={t('Generic.Hour.Full')} value={hours} onChange={(e) => setHours(parseInt(e.target.value))} classNames="basis-20 bg-white border-y border-l border-gray-300  rounded-lg p-2 after:absolute after:-right-0 after:bottom-4.5 after:content-[':'] after:translate-x-1/2 after:z-1" />
            <Input type="number" label={t('Generic.Minute.Full')} value={minutes} onChange={(e) => setMinutes(parseInt(e.target.value))} classNames="basis-20 bg-white border-y border-gray-300 rounded-lg p-2 after:absolute after:-right-0 after:bottom-4.5 after:content-[':'] after:translate-x-1/2 after:z-1" />
            <Input type="number" label={t('Generic.Second.Full')} value={seconds} onChange={(e) => setSeconds(parseInt(e.target.value))} classNames="basis-20 bg-white border-y border-r border-gray-300 rounded-lg p-2 after:z-1" />
        </fieldset>
    );
};
